export * from './IconText';
export * from './IconText.type';
